var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 162,
    viewBox: "0 0 161 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.336 95.396C99.1772 95.5068 99.0133 95.6117 98.8446 95.7104L93.3633 98.9157L71.8673 86.3453V75.6422L93.3526 63.078L98.8446 66.2896C99.0379 66.4026 99.2248 66.5238 99.405 66.6526L84.0519 75.6147V75.5928L77.8987 79.2066V82.8821L84.0519 86.488V82.8376L102.473 72.0654C102.491 72.2761 102.5 72.4886 102.5 72.7024V79.1865L90.2336 86.3954L90.2336 90.0978L99.336 95.396Z",
    fill: "url(#paint0_radial_3044_17610)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1994 59.4797L84.6554 57.9921C82.3934 56.6693 79.6066 56.6693 77.3446 57.9921L63.1554 66.2896C60.8934 67.6124 59.5 70.0569 59.5 72.7024V89.2976C59.5 91.9431 60.8934 94.3876 63.1554 95.7104L77.3446 104.008C79.6066 105.331 82.3934 105.331 84.6554 104.008L87.2101 102.514L65.7141 89.9436L65.7141 72.0486L65.7226 72.0535L65.7141 72.0439L87.1994 59.4797Z",
    fill: "url(#paint1_radial_3044_17610)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "circle-rotate",
    d: "M40.5 81C40.5 85.4765 41.2353 89.7812 42.5918 93.8M80.5 41C78.8067 41 77.138 41.1052 75.5 41.3095M120.5 81C120.5 87.2362 119.073 93.1392 116.527 98.4M80.5 121C78.3912 121 76.3206 120.837 74.3 120.522M111.727 106C107.037 111.85 100.738 116.354 93.5 118.84M63.8922 117.4C57.1762 114.331 51.4573 109.458 47.3555 103.4M40.8614 75.6C41.6585 69.6935 43.7447 64.196 46.8276 59.4M53.1 51.8581C58.024 47.2266 64.122 43.8291 70.9 42.1594M87.7 41.6463C94.2652 42.8396 100.272 45.6355 105.3 49.6139M114.914 60.6C115.643 61.8259 116.307 63.0941 116.904 64.4",
    stroke: "url(#paint2_radial_3044_17610)",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "circle-rotate",
    d: "M0.499991 81C0.499991 89.953 1.97067 98.5624 4.68364 106.6M80.5 1C77.1134 1 73.7759 1.21043 70.5 1.61894M160.5 81C160.5 93.4725 157.646 105.278 152.555 115.8M80.5 161C76.2825 161 72.1412 160.674 68.1 160.045M142.954 131C133.574 142.7 120.975 151.708 106.5 156.68M47.2843 153.8C33.8523 147.662 22.4146 137.915 14.2109 125.8M1.22278 70.2C2.81693 58.387 6.98941 47.392 13.1552 37.8M25.7 22.7162C35.5481 13.4533 47.744 6.65821 61.3 3.31888M94.9 2.29252C108.03 4.67921 120.044 10.2709 130.1 18.2277M149.328 40.2C150.785 42.6519 152.114 45.1883 153.307 47.8",
    stroke: "url(#paint3_radial_3044_17610)",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "circle-rotate _reverse",
    d: "M80.5 141C73.7853 141 67.3282 139.897 61.3 137.862M140.5 81C140.5 83.54 140.342 86.043 140.036 88.5M80.5 21C71.1456 21 62.2912 23.1407 54.4 26.9589M20.5 81C20.5 84.1631 20.7448 87.2691 21.2164 90.3M43 34.1597C34.2248 41.1942 27.4688 50.6436 23.7399 61.5M25.9 105.912C30.5038 115.986 37.8137 124.564 46.9 130.717M88.6 140.458C97.4598 139.262 105.706 136.133 112.9 131.509M124.213 122.1C131.16 114.714 136.256 105.567 138.761 95.4M139.531 70.2C137.741 60.3521 133.547 51.3422 127.579 43.8M111.1 29.3787C109.261 28.2863 107.359 27.2893 105.4 26.3946",
    stroke: "url(#paint4_radial_3044_17610)",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3044_17610",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.3706 100.895) rotate(-54.8086) scale(43.739 70.3422)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31D8BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0965F1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3044_17610",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.3706 100.895) rotate(-54.8086) scale(43.739 70.3422)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31D8BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0965F1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3044_17610",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(100.276 114.159) rotate(-128.21) scale(75.8189 125.828)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31D8BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0965F1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3044_17610",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(120.051 147.318) rotate(-128.21) scale(151.638 251.656)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31D8BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0965F1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3044_17610",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.7617 51.3365) rotate(38.2097) scale(113.728 188.742)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31D8BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0965F1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.54e241527aec14471a4d0307a6b86854.svg";
export { ForwardRef as ReactComponent };